import React, { useState, useEffect } from 'react'
import { getData } from '../../../actions/servicesHttp'
import ReturnButton from '../../../components/generals/buttonReturn'
import { useParams, useNavigate } from 'react-router-dom'
// import styles from '../../../css/devices/ConnectionsHistory.module.css'
import Header from '../../../components/generals/header'
import stylesIndex from '../../../css/Index.module.css'
import { formatDate } from '../../../components/generals/charts/utils/DatesFormats'
import DataTableDemo from '../../../components/generals/datatables/datatable'
import store from '../../../reducer/store'
import { useTranslation } from 'react-i18next'

export default function ConnectionsHistory () {
  const { id } = useParams()
  const { t } = useTranslation('dashboardDevice')
  const { user } = store.getState()
  const role = user.roles
  const navigate = useNavigate()
  const [connections, setConnections] = useState([])
  const [device, setDevice] = useState(null)
  const [urlAllDevicesConnections] = useState('device/all_connections')
  const [deviceUrl] = useState('device/data')

  const columns = [
    { field: 'date', header: t('connectionsHistory.header1') },
    { field: 'ip_lan', header: t('connectionsHistory.header2') },
    { field: 'ip_wan', header: t('connectionsHistory.header3') }

  ]

  const getAllDevicesConnections = async (url, id) => {
    const response = await getData(url, id, navigate)

    if (response?.status === 200) {
      const connections = response?.data?.map((element) => {
        element.date = formatDate(element.date)
        return element
      })
      setConnections(connections)
    }
  }

  const getRequest = async (url, data, set) => {
    const response = await getData(url, data, navigate)
    if (response?.status === 200) {
      response.data.last_date = formatDate(response.data.last_date)
      set(response.data)
    }
  }

  useEffect(() => {
    getAllDevicesConnections(urlAllDevicesConnections, id)
  }, [urlAllDevicesConnections, id])

  useEffect(() => {
    getRequest(deviceUrl, id, setDevice)
  }, [deviceUrl, id])

  return (
      <div className={`content-wrapper  ${stylesIndex.flexContent}`}>
        <div className={`content  ${stylesIndex.mainContent}`}>
          <Header title={t('connectionsHistory.title')} />
          <div style={{ display: 'flex', justifyContent: 'flex-start', marginBottom: '1rem' }}>
            <ReturnButton redirect={`device/${id}`} />
          </div>
          <div>
            <DataTableDemo
              data={connections}
              editUsers={false}
              rowStates={false}
              rowSelecteds={false}
              exportsPdf={role?.dashboardDevicePage.exportPdfInAllDevicesConnections}
              exportsCsv={role?.dashboardDevicePage.exportCsvInAllDevicesConnections}
              actionDelete={false}
              actionDashboard={false}
              table="allDevicesConnections"
              searchs={['date', 'ip_lan', 'ip_wan']}
              columns={columns}
              namePdf={`${t('connectionsHistory.namePdf')} ${device?.serial_number}`}
            />
          </div>
        </div>
      </div>)
}
